// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { useNavigate, Link } from "react-router-dom";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Badge from "../../../components/Badge";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import InputGroup from "../../../components/FormComponent/InputGroup";
import useValidator from "../../../hooks/useValidator";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import { useUserState } from "../../../context/UserContext";

// ALl API Endpoints
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const CLASSES_ENDPOINT = "/api/v1/class";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const SCHOOL_TEST = "/api/v1/tests";
const TEST_CONFIG_ENDPOINT = "/api/v1/test-configs";

const AdminCA = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const { userRole } = useUserState();
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const [allCATest, setAllCATest] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [itemModal, setItemModal] = useState(false);
  const [scoreCreateLoading, setScoreCreateLoading] = useState(false);
  const [testValidator, showTestValidator] = useValidator();
  const [getIsLoading, setGetIsLoading] = useState(false);
  const [bookError, setBookError] = useState("");
  const width = useWindowSize();
  const isMobile = width < 600;
  const preserveCheckboxStatus = String(currentRow?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";
  const isTeacher = userRole?.role_type === "employee";
  // const [integration, setSchoolIntegration] = useState([]);
  const [caform, setCaForm] = useState({
    session_id: "",
    CA1: "",
    CA2: "",
    examination: ""
  });

  /**
 * Handles changes to the CA form fields and validates the total score.
 * Ensures that CA1 + CA2 + Examination equals 100.
 *
 * @param {Object} e - The event object from input change.
 */
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = { ...caform, [name]: value };

    // Check if the name is CA1, CA2, or examination, then validate total
    if (["CA1", "CA2", "examination"].includes(name)) {
      const ca1 = updatedForm?.CA1 || 0;
      const ca2 = updatedForm?.CA2 || 0;
      const exam_score = updatedForm?.examination || 0;
      const total = Number(ca1) + Number(ca2) + Number(exam_score);

      // Validate total score
      if (total === 100) {
        setBookError("");
      } else {
        setBookError("All scores should sum up to 100");
      }
    }

    setCaForm(updatedForm);
  };

  /**
 * Closes the delete confirmation modal.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  /**
 * Opens the delete confirmation modal for the selected row.
 *
 * @param {Object} row - The data row selected for deletion.
 */
  const handleDeleteModal = (row) => {
    const status = String(row?.status || "").toLowerCase();
    if (["published", "expired", "scheduled"].includes(status)) {
      toast.error("Published, expired, and scheduled tests cannot be deleted.");

      return;
    }
    setCurrentRow(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  /**
 * Toggles the item modal for creating a CA entry and resets the form.
 */
  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
    setCaForm({ session_id: activeSession?.id, CA1: "", CA2: "", examination: "" });
  };

  /**
 * Validates and submits the CA score form to create a new score record.
 * Displays success or error messages based on API response.
 */
  const handleCreateScore = () => {
    if (bookError) {
      toast.error("Please ensure the total score is 100 before proceeding.");

      return;
    }

    if (testValidator.allValid()) {
      setScoreCreateLoading(true);
      httprequest
        .post(OBTAINABLE_SCORE, caform)
        .then((res) => {
          setScoreCreateLoading(false);
          toast.success(res?.data?.message || "SCore created successfully");
          handleOpenItemMOdal();
        })
        .catch((err) => {
          setScoreCreateLoading(false);
          toast.error(err?.response?.data || "An error occurred");
        });
    } else {
      showTestValidator(true);
    }
  };

  /**
 * Fetches all terms and filters them by session ID.
 *
 * @param {string|number} Session_ID - ID of the session to fetch terms for.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Retrieves all school test records based on selected term.
 *
 * @param {string|number} aselectedTerm - ID of the selected term.
 */
  const getSchoolTest = (aselectedTerm) => {
    setGetIsLoading(true);
    httprequest
      .get(`${SCHOOL_TEST}?term_id=${aselectedTerm}`)
      .then((res) => {
        setAllCATest(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetIsLoading(false);
      }).catch((err) => {
        setGetIsLoading(false);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Sends a request to delete a test entry and refreshes the test list.
 */
  const handleDeleteTEst = () => {
    setisDeleting(true);
    httprequest
      .delete(`${TEST_CONFIG_ENDPOINT}/${currentRow?.id}`, {
        data: {
          preserve_questions_in_bank: !!preserveQuestionsInBank
        }
      })
      .then((res) => {
        setisDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        getSchoolTest(aselectedTerm);
      })
      .catch((err) => {
        setisDeleting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Fetches all academic sessions and sets the current active session.
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      const foundSession = res?.data?.data?.find((session) => session?.current_session === true);
      setActiveSession(foundSession);
      setCaForm((prevCaForm) => ({ ...prevCaForm, session_id: foundSession?.id }));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Fetches all class records based on user role (teacher or admin).
 */
  const getAllClasses = () => {
    // setIsPageFetching(true);
    const CLASS_ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : CLASSES_ENDPOINT;
    httprequest
      .get(CLASS_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data;
        // setIsPageFetching(false);
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
   * Find Active Term in an Current Session
   */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session selection change and triggers term fetch for selected session.
 *
 * @param {Object} e - The event object from session select input.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Handles term selection and fetches CA tests associated with the selected term.
 *
 * @param {Object} event - The event object from term select input.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getSchoolTest(selectedTermId);
  };

  /**
 * Filters the CA test list based on selected class name.
 *
 * @param {Object} e - The event object from the class filter dropdown.
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter Test based on status when the filter is applied
    const filteredByStatus = value
      ? allCATest?.filter((data) => data?.class?.name?.toLowerCase() === value.toLowerCase()
      )
      : allCATest;

    setSearchResult(filteredByStatus);
  };

  const columns = [
    {
      name: "Subject",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Title",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.title || "--/--"}
        </>
      )
    },
    {
      name: "CA Test",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.ca_type || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Created By</p>}
          {`${row?.created_by?.last_name || "--/--"} ${row?.created_by?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Type",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column" }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={row?.status === "converted" ? `/assignments/${row?.id}` : `/assessment-detail/${row?.id}`}>
            <button className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </Link>
          <button
            className="table-action-icon"
            onClick={() => {
              const route = row?.status === "converted"
                ? `/assignments/${row?.id}`
                : `/assessment-detail/${row?.id}?editConfig`;
              navigate(route);
            }}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button onClick={() => handleDeleteModal(row)} className="table-action-icon delete-icon">
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Filters CA tests based on multiple search keywords like title, subject, or status.
 *
 * @param {Object} e - The event object from the search input.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? allCATest?.filter((data) => data?.class?.name?.toLowerCase() === value.toLowerCase()
      )
      : allCATest;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.subject?.name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.title
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.ca_type
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * On component mount, fetch all necessary classes, sessions, and terms.
 */
  useEffect(() => {
    getAllClasses();
    getAllSessions();
    getAllTerms();
  }, []);

  /**
 * On detection of active term, set selected term and fetch CA tests.
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      getSchoolTest(active_term_session?.id);
    }
  }, [active_term_session]);

  /**
 * When the active session changes, fetch the terms for that session.
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <Layout children={
      <>
        <PageTitle
          title="CA Tests"
          subtitle="See all CA information"
          button={
            <div className="flex gap-10">
              <div className="flex gap-10">
                {isTeacher ? null : <Button onClick={() => navigate("/obtainable-score")} variant="primaryoutline" buttonSize="fluid" color="btnfontprimary" buttonName="Set Obtainable Score" />}
                <Button onClick={() => navigate("/create-assessment")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create CA Test" />
              </div>
            </div>
          }
        />

        <div className="flex gap-10 align-items-end margin-top-5 margin-bottom">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            <SelectGroup
              children={
                <select onChange={handleFilterChange}>
                  <option value="">Class</option>
                  {classesData?.map((data) => {
                    return (
                      <option key={isTeacher ? data?.class?.id : data?.id} value={isTeacher ? data?.class?.name : data?.class_name}>
                        {isTeacher ? data?.class?.name : data?.class_name}
                      </option>
                    );
                  })}
                </select>
              }
            />
          </div>
        </div>

        <div className="page-content margin-top-30">
          <>
            {getIsLoading ? (
              <PageLoader />
            ) : (
              <Table
                data={searchResult}
                columns={columns}
                subHeader={true}
                pagination
                subHeaderComponent={
                  <div className="action_div">
                    <TableSearch
                      placeholder="Search here..."
                      searchTableFunc={handleSearchStudent}
                    />
                    <div className="text-center gap-10 cursor-pointer">
                      {/* <div>
                    <SelectGroup
                      children={
                        <select name="type" onChange={handleFilterChange}>
                          <option value="">-- Item --</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      }
                    />
                  </div> */}
                      {/* <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Fee Status --</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          }
                        />
                      </div>
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handlePaymentFilterChange}>
                              <option value="">-- Payment Method --</option>
                              <option value="active">Bank Transfer</option>
                              <option value="inactive">Payment Gateway</option>
                            </select>
                          }
                        />
                      </div> */}
                    </div>
                  </div>}
              />
            )}
          </>
        </div>
        {/* Add Option */}
        <Modal
          title="Set Obtainable Score"
          subtitle={
            <div>
                You can set the obtainable score for CA and Exam
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Session"
                    required
                    children={
                      <select defaultValue={activeSession?.id} name="session_id" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {allSessions?.map((sesh) => {
                          return (
                            <option key={sesh.id} value={sesh?.id}>
                              {sesh?.session}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {testValidator.message("Session", caform?.session_id, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="CA 1"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="CA1"
                    onChange={handleChange}
                  />
                  {testValidator.message("CA 1", caform?.CA1, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="CA 2"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="CA2"
                    onChange={handleChange}
                  />
                  {testValidator.message("CA 2", caform?.CA2, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Examination"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="examination"
                    onChange={handleChange}
                  />
                  {testValidator.message("Examination", caform?.examination, "required")}
                  {bookError && <p className="text-danger">{bookError}</p>}

                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                  onClick={handleOpenItemMOdal}
                //   isLoading={resultCreating}
                />
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Save Obtainable Score"
                  onClick={handleCreateScore}
                  isLoading={scoreCreateLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Test"
          subtitle={
            <div>
            Are you sure you want to remove{" "}
              <span className="modal-name-highlight">
                {currentRow?.title}
              </span>
              {" "}from one of your Test? Removing it will permanently
            clear this Test.
            </div>
          }
          modalContent={shouldShowPreserveQuestionsCheckbox ? (
            <div style={{ marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={preserveQuestionsInBank}
                  onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
                />
                Preserve questions on this Test and add them to bank.
              </label>
            </div>
          ) : <></>}
          modalFooter={
            <>
              <div className="flex gap-10">
                {/* <Button
                  variant="dangeroutline"
                  buttonSize="full"
                  color="btndanger"
                  buttonName="Cancel"
                  onClick={handleCloseDeleteModal}
                /> */}
                <Button
                  variant="danger"
                  buttonName="Delete Test"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleDeleteTEst}
                  isLoading={isDeleting}
                />
              </div>
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default AdminCA;
